/**
 * SubscribeUserCTAFooter
 *
 * Sticky-bottom CTA row with a positive (subscribe / unsubscribe / send-request
 * / cancel-request) button and a secondary "Close" button. Used inside
 * SubscribeUserSheetContent.
 */
import React from 'react';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { CTAButtons } from '@/presentation/components/common/sheet/service/components/CTAButtons';
import { SheetCTAFooter } from '@/presentation/components/common/sheet/service/components/SheetCTAFooter';

interface SubscribeUserCTAFooterProps {
  positiveText: string;
  isSubscribing: boolean;
  fetching: boolean;
  onPositive: () => void;
  onClose: () => void;
}

export const SubscribeUserCTAFooter: React.FC<SubscribeUserCTAFooterProps> = ({
  positiveText,
  isSubscribing,
  fetching,
  onPositive,
  onClose,
}) => {
  const { theme } = useTheme();
  const { l10n } = useLocale();

  return (
    <SheetCTAFooter>
      <CTAButtons
        cta={{
          buttons: [
            {
              text: positiveText,
              onClick: onPositive,
              qaId: 'subscribe-user-confirm',
              // Not needed to show loading state on the button itself since we have a
              // full-sheet loading overlay
              disabled: fetching || isSubscribing,
              closeOnClick: false,
              textColor: theme.exclusive,
            },
            {
              text: l10n.common.close,
              onClick: onClose,
            },
          ],
        }}
        onClose={() => {
          /* CTAButtons handles the auto-close via closeOnClick */
        }}
      />
    </SheetCTAFooter>
  );
};
